import React from "react";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { Descriptions, Tooltip } from "antd";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); //if Mobile

export default ({ contract }) => {
  const columns = contract.isApplicants ? 9 : 8;
  return (
    <Descriptions size="small" column={isMobile ? 2 : columns}>
      <Descriptions.Item label="Target">
        <Tooltip title={contract.manualTarget ? "contract" : "campaigns"}>
          {contract.target}
        </Tooltip>
      </Descriptions.Item>
      {contract.isApplicants && (
        <>
          <Descriptions.Item label="Applicants">
            {contract.totalApplicants}
          </Descriptions.Item>
        </>
      )}
      {contract.throttle && (
        <Descriptions.Item
          label="Throttle"
          contentStyle={{ alignItems: "center" }}
        >
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        </Descriptions.Item>
      )}
      {contract.metaPartnershipAdsEnabled && (
        <Descriptions.Item
          label="Partnership Ads"
          contentStyle={{ alignItems: "center" }}
        >
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        </Descriptions.Item>
      )}
      <Descriptions.Item label="Fee">${contract.fee}</Descriptions.Item>
      {/* Revenue is stored in database as 2723000, convert to Millions with no decimal, round up */}
      <Descriptions.Item label="Revenue">
        {contract.revenue && contract.revenue > 1
          ? `$${Math.ceil(contract.revenue / 1000000)}M`
          : "N/A"}
      </Descriptions.Item>
      <Descriptions.Item label="Onboards">
        {contract.totalOnboards}
      </Descriptions.Item>
      {/* <Descriptions.Item label="Not Started">
        {contract.not_started}
      </Descriptions.Item>
      <Descriptions.Item label="Started">{contract.started}</Descriptions.Item> */}
      <Descriptions.Item label="Done">{contract.done}</Descriptions.Item>
      <Descriptions.Item label="CTR">{contract.followed_up}</Descriptions.Item>
      <Descriptions.Item label="Not Interested">
        {contract.not_interested}
      </Descriptions.Item>
    </Descriptions>
  );
};
